function Greeting({ text }) {
	return (
		<div>
			<h1 className="text-muted">{text}</h1>
		</div>
	);
}

export default Greeting;
